import { Box, Typography } from "@mui/material";
import { useBlockedUsersQuery } from "Api/Queries/Social/useBlockedUsersQuery";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Social.People;

/**
 * "Blocked users (n)" link to the blocked-users page, shown under the People
 * tabs only when someone is actually blocked. The first page is fetched here
 * only for the count; React Query dedupes it with the blocked page's own query.
 */
export const BlockedUsersLink = () => {
  const { t } = useResource();
  const { data: blocked } = useBlockedUsersQuery();

  if (!blocked?.totalCount) {
    return null;
  }

  return (
    <Box textAlign="right">
      <UnstyledLink to={appUrl("blocked-users")}>
        <Typography component="span" color="text.secondary">
          {t(RESOURCES.BlockedTitle)} ({blocked.totalCount})
        </Typography>
      </UnstyledLink>
    </Box>
  );
};
